import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mb-0 text-bold"
}
const _hoisted_2 = ["href", "title"]
const _hoisted_3 = {
  key: 0,
  class: "d-block text-muted"
}
const _hoisted_4 = {
  key: 1,
  class: "mb-0 text-bold"
}
const _hoisted_5 = { class: "d-flex align-items-center" }
const _hoisted_6 = { style: {"line-height":"1.25rem"} }
const _hoisted_7 = {
  key: 0,
  class: "text-danger d-flex flex-nowrap overflow-hidden"
}
const _hoisted_8 = { class: "text-nowrap mr-1" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-exclamation-circle" }, null, -1)
const _hoisted_10 = {
  key: 0,
  class: "text-bold"
}
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { class: "d-flex justify-content-end flex-grow-1" }
const _hoisted_13 = { class: "row-expansion-content" }
const _hoisted_14 = { class: "d-flex align-items-center ml-1 ml-lg-0" }
const _hoisted_15 = { class: "d-flex flex-column" }
const _hoisted_16 = { class: "mb-0 text-muted d-block" }
const _hoisted_17 = {
  key: 0,
  class: "mb-0 text-bold"
}
const _hoisted_18 = ["href", "title"]
const _hoisted_19 = {
  key: 1,
  class: "mb-0 text-bold"
}
const _hoisted_20 = {
  key: 2,
  class: "badge badge-primary multi-user-badge"
}
const _hoisted_21 = {
  key: 3,
  class: "text-info text-bold"
}
const _hoisted_22 = { key: 0 }
const _hoisted_23 = { key: 1 }
const _hoisted_24 = {
  key: 0,
  class: "mb-0 text-bold"
}
const _hoisted_25 = ["href", "title"]
const _hoisted_26 = {
  key: 1,
  class: "mb-0 text-bold"
}
const _hoisted_27 = { class: "lead" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Column = _resolveComponent("Column")!
  const _component_Avatar = _resolveComponent("Avatar")!
  const _component_AvatarGroup = _resolveComponent("AvatarGroup")!
  const _component_PopoverIcon = _resolveComponent("PopoverIcon")!
  const _component_Button = _resolveComponent("Button")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_Message = _resolveComponent("Message")!
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.contracts.length)
      ? (_openBlock(), _createBlock(_component_DataTable, {
          key: 0,
          "expanded-rows": _ctx.expandedRows,
          "onUpdate:expandedRows": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.expandedRows) = $event)),
          "auto-layout": "",
          "data-key": "contractNumber",
          "responsive-layout": "stack",
          "row-class": _ctx.highlightRow,
          "row-hover": true,
          value: _ctx.contracts,
          class: "contract-table",
          breakpoint: "991px",
          onRowClick: _withModifiers(_ctx.onRowClick, ["self"])
        }, {
          expansion: _withCtx((item) => [
            _createElementVNode("div", _hoisted_13, [
              (_ctx.getContractAssets(item.data).length)
                ? (_openBlock(), _createBlock(_component_DataTable, {
                    key: 0,
                    "auto-layout": "",
                    "responsive-layout": "stack",
                    value: _ctx.getContractAssets(item.data)
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_Column, {
                        field: "productName",
                        header: _ctx.$t('myCadac.contractOverview.table.colProductName'),
                        sortable: false
                      }, {
                        body: _withCtx((asset) => [
                          _createElementVNode("div", _hoisted_14, [
                            _createVNode(_component_Avatar, {
                              alt: asset.data.productIconAlt,
                              class: "mr-1 bg-transparent flex-shrink-0",
                              image: asset.data.productIconUrl,
                              shape: "square",
                              size: "large",
                              title: asset.data.productName
                            }, null, 8, ["alt", "image", "title"]),
                            _createElementVNode("div", _hoisted_15, [
                              _createElementVNode("small", _hoisted_16, _toDisplayString(asset.data.productBrand), 1),
                              (_ctx.userProfile?.isCadacSales || _ctx.userProfile?.isImpersonated)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_17, [
                                    _createElementVNode("a", {
                                      href: asset.data.productCrmUrl,
                                      target: "_blank",
                                      title: _ctx.$t('common.goToCrm')
                                    }, _toDisplayString(_ctx.formatProductName(asset.data.productName, asset.data.productBrand)), 9, _hoisted_18)
                                  ]))
                                : (_openBlock(), _createElementBlock("p", _hoisted_19, _toDisplayString(_ctx.formatProductName(asset.data.productName, asset.data.productBrand)), 1)),
                              (asset.data.isMultiSizeProduct)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(asset.data.multiSizeUnitString), 1))
                                : _createCommentVNode("", true),
                              (_ctx.isAssetSwitched(asset.data))
                                ? (_openBlock(), _createElementBlock("small", _hoisted_21, _toDisplayString(_ctx.$t("myCadac.contractDetail.table.productSwitchedMessage")), 1))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ]),
                        _: 1
                      }, 8, ["header"]),
                      _createVNode(_component_Column, {
                        field: "serialNumber",
                        header: _ctx.$t('myCadac.contractOverview.table.colProductSerialNumber'),
                        sortable: false,
                        style: {"width":"20%"}
                      }, {
                        body: _withCtx((asset) => [
                          (_ctx.isContractExpired(item.data))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_22, _toDisplayString(_ctx.$t("common.notApplicable")), 1))
                            : (_openBlock(), _createElementBlock("div", _hoisted_23, [
                                (_ctx.userProfile?.isCadacSales || _ctx.userProfile?.isImpersonated)
                                  ? (_openBlock(), _createElementBlock("p", _hoisted_24, [
                                      _createElementVNode("a", {
                                        href: asset.data.crmUrl,
                                        target: "_blank",
                                        title: _ctx.$t('common.goToCrm')
                                      }, _toDisplayString(asset.data.serialNumber || _ctx.$t("common.notApplicable")), 9, _hoisted_25)
                                    ]))
                                  : (_openBlock(), _createElementBlock("p", _hoisted_26, _toDisplayString(asset.data.serialNumber || _ctx.$t("common.notApplicable")), 1))
                              ]))
                        ]),
                        _: 2
                      }, 1032, ["header"]),
                      _createVNode(_component_Column, {
                        field: "deployment",
                        header: _ctx.$t('myCadac.contractOverview.table.colProductLicenceType'),
                        hidden: _ctx.isSupportContractTable,
                        sortable: false,
                        style: {"width":"20%"}
                      }, {
                        body: _withCtx((asset) => [
                          _createTextVNode(_toDisplayString(_ctx.$t(`enum.deployment.${asset.data.deployment}`)), 1)
                        ]),
                        _: 1
                      }, 8, ["header", "hidden"]),
                      _createVNode(_component_Column, {
                        field: "seats",
                        header: _ctx.$t('myCadac.contractOverview.table.colProductSeats'),
                        hidden: _ctx.isSupportContractTable,
                        sortable: false,
                        style: {"width":"20%"}
                      }, null, 8, ["header", "hidden"])
                    ]),
                    _: 2
                  }, 1032, ["value"]))
                : (_openBlock(), _createBlock(_component_Message, {
                    key: 1,
                    closable: false,
                    severity: "warn"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("myCadac.contractOverview.message.noContractAssets")), 1)
                    ]),
                    _: 1
                  }))
            ])
          ]),
          default: _withCtx(() => [
            (!_ctx.isSmallScreen)
              ? (_openBlock(), _createBlock(_component_Column, {
                  key: 0,
                  expander: "",
                  "header-style": "width:1.75rem"
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_Column, {
              key: "contractNumber",
              field: "contractNumber",
              header: _ctx.$t('myCadac.contractOverview.table.colContractNumber'),
              sortable: false
            }, {
              body: _withCtx((item) => [
                (_ctx.userProfile?.isCadacSales || _ctx.userProfile?.isImpersonated)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_1, [
                      _createElementVNode("a", {
                        href: item.data.crmUrl,
                        target: "_blank",
                        title: _ctx.$t('common.goToCrm')
                      }, _toDisplayString(item.data.contractNumber), 9, _hoisted_2),
                      (item.data.crmBusinessUnit)
                        ? (_openBlock(), _createElementBlock("small", _hoisted_3, _toDisplayString(_ctx.$t("myCadac.contractOverview.table.lblCrmBusinessUnit", {
								name: item.data.crmBusinessUnit.name,
							})), 1))
                        : _createCommentVNode("", true)
                    ]))
                  : (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(item.data.contractNumber), 1))
              ]),
              _: 1
            }, 8, ["header"]),
            _createVNode(_component_Column, {
              key: "products",
              field: "products",
              header: _ctx.$t('myCadac.contractOverview.table.colProducts'),
              sortable: false
            }, {
              body: _withCtx((item) => [
                _createVNode(_component_AvatarGroup, null, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getSortedContractAssets(item.data).slice(
							0,
							_ctx.maxContractAssetsToShow
						), (asset, index) => {
                      return (_openBlock(), _createBlock(_component_Avatar, {
                        key: index,
                        alt: asset.productIconAlt,
                        class: "ml-0 bg-transparent",
                        image: asset.productIconUrl,
                        shape: "square",
                        size: "small",
                        title: asset.productName
                      }, null, 8, ["alt", "image", "title"]))
                    }), 128)),
                    (_ctx.getContractAssets(item.data).length > _ctx.maxContractAssetsToShow)
                      ? (_openBlock(), _createBlock(_component_Avatar, {
                          key: 0,
                          class: "text-bold ml-0",
                          label: `+${_ctx.getContractAssets(item.data).length - _ctx.maxContractAssetsToShow}`,
                          shape: "square",
                          size: "small"
                        }, null, 8, ["label"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 1
            }, 8, ["header"]),
            _createVNode(_component_Column, {
              key: "renewalTerm",
              field: "renewalTerm",
              header: _ctx.$t('myCadac.contractOverview.table.colDuration'),
              sortable: false
            }, null, 8, ["header"]),
            _createVNode(_component_Column, {
              key: "automaticRenewal",
              field: "automaticRenewal",
              header: _ctx.$t('myCadac.contractOverview.table.colAutomaticRenewal'),
              sortable: false
            }, {
              body: _withCtx((item) => [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("i", {
                    class: _normalizeClass(
							item.data.automaticRenewal
								? 'pi pi-check text-success mr-1'
								: 'pi pi-times text-danger mr-1'
						)
                  }, null, 2),
                  _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.getAutomaticRenewalText(item.data.automaticRenewal)), 1)
                ])
              ]),
              _: 1
            }, 8, ["header"]),
            _createVNode(_component_Column, {
              key: "endDate",
              field: "endDate",
              header: _ctx.$t('myCadac.contractOverview.table.colExpiresOn'),
              sortable: false
            }, {
              body: _withCtx((item) => [
                (_ctx.shouldShowContractExpirationWarning(item.data))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.formatDate(item.data.endDate)), 1),
                      _createVNode(_component_PopoverIcon, {
                        class: "d-inline-flex",
                        style: {"line-height":"1.75rem"}
                      }, {
                        content: _withCtx(() => [
                          _createElementVNode("p", null, _toDisplayString(_ctx.$tc("myCadac.contractOverview.table.contractExpirationWarning", {
										count: item.data.remainingDays,
									})), 1),
                          (
									(_ctx.userProfile?.isCadacSales || _ctx.userProfile?.isImpersonatedByCadacSales) &&
									item.data.contractFaultRemarks
								)
                            ? (_openBlock(), _createElementBlock("small", _hoisted_10, _toDisplayString(item.data.contractFaultRemarks), 1))
                            : _createCommentVNode("", true)
                        ]),
                        default: _withCtx(() => [
                          _hoisted_9
                        ]),
                        _: 2
                      }, 1024)
                    ]))
                  : (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_ctx.formatDate(item.data.endDate)), 1))
              ]),
              _: 1
            }, 8, ["header"]),
            _createVNode(_component_Column, {
              key: "actions",
              style: {"width":"25%"}
            }, {
              body: _withCtx((item) => [
                _createElementVNode("div", _hoisted_12, [
                  (_ctx.canExtendOrRenewContract(item.data) && item.data.isPerpetual)
                    ? (_openBlock(), _createBlock(_component_Button, {
                        key: 0,
                        class: "p-button-success p-button-sm mr-auto mr-lg-1 flex-grow-lg-1",
                        label: _ctx.$t('myCadac.contractOverview.button.switchContractOptions'),
                        onClick: ($event: any) => {
							_ctx.openUrl(`${_ctx.vm.contractDetailPageUrl}?contractnumber=${item.data.contractNumber}`);
							$event.target.disabled = true;
						}
                      }, null, 8, ["label", "onClick"]))
                    : _createCommentVNode("", true),
                  (_ctx.canExtendOrRenewContract(item.data) && !item.data.isPerpetual)
                    ? (_openBlock(), _createBlock(_component_Button, {
                        key: 1,
                        class: "p-button-success p-button-sm mr-auto mr-lg-1 flex-grow-lg-1",
                        label: _ctx.$t('myCadac.contractOverview.button.renewContract'),
                        onClick: ($event: any) => {
							_ctx.openUrl(`${_ctx.vm.contractDetailPageUrl}?contractnumber=${item.data.contractNumber}`);
							$event.target.disabled = true;
						}
                      }, null, 8, ["label", "onClick"]))
                    : _createCommentVNode("", true),
                  _createVNode(_component_Button, {
                    class: "p-button-primary p-button-icon p-button-rounded p-button-raised p-button-text ml-1 flex-shrink-0",
                    icon: _ctx.canEditContract(item.data) ? 'pi pi-pencil' : 'pi pi-eye',
                    label: 
							_ctx.isSmallScreen
								? _ctx.canEditContract(item.data)
									? _ctx.$t('myCadac.contractOverview.button.changeContract')
									: _ctx.$t('common.view')
								: ''
						,
                    title: 
							_ctx.canEditContract(item.data)
								? _ctx.$t('myCadac.contractOverview.button.changeContract')
								: _ctx.$t('common.view')
						,
                    onClick: ($event: any) => {
							_ctx.openUrl(
								`${_ctx.vm.contractChangePageUrl}?contractnumber=${
									item.data.contractNumber
								}&edit=${_ctx.canEditContract(item.data)}`
							);
							$event.target.disabled = true;
						}
                  }, null, 8, ["icon", "label", "title", "onClick"]),
                  (_ctx.canCancelContract(item.data))
                    ? (_openBlock(), _createBlock(_component_Button, {
                        key: 2,
                        class: "p-button-primary p-button-icon p-button-rounded p-button-raised p-button-text ml-1 flex-shrink-0",
                        icon: "pi pi-times",
                        label: _ctx.isSmallScreen ? _ctx.$t('myCadac.contractOverview.button.cancelContract') : '',
                        title: _ctx.$t('myCadac.contractOverview.button.cancelContract'),
                        onClick: ($event: any) => (_ctx.cancelContract(item.data))
                      }, null, 8, ["label", "title", "onClick"]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["expanded-rows", "row-class", "value", "onRowClick"]))
      : _createCommentVNode("", true),
    (!_ctx.contracts.length)
      ? (_openBlock(), _createBlock(_component_Card, {
          key: 1,
          class: "mx-auto mt-2"
        }, {
          content: _withCtx(() => [
            _createElementVNode("p", _hoisted_27, _toDisplayString(_ctx.isSupportContractTable || !_ctx.contracts.length
						? _ctx.$t("myCadac.contractOverview.card.noSupportContracts")
						: _ctx.$t("myCadac.contractOverview.card.noContracts")), 1)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ], 64))
}